import React from 'react'

const Flexed = ({children}) => {
  return (
    <div className='block h-auto lg:h-screen overflow-auto lg:overflow-hidden md:flex md:justify-center'>{children}</div>
  )
}

export default Flexed